import retrieveCase from 'app/modules/casesOld/sagas/retrieveCase';

const sagaRegistry = [retrieveCase];

export default sagaRegistry;
